import { useCallback } from 'react';

import { useMainActions } from '../store';

export const useGetProjectAttributes = () => {
  const mainActions = useMainActions();

  return useCallback(() => {
    const project = mainActions.getProject();
    const generationTool = mainActions.getGenerationTool();
    const customMultiPromptId = mainActions.getCustomMultiPromptId();

    return {
      projectId: project?.id,
      generationTool,
      customMultiPromptId,
    };
  }, [mainActions]);
};
